import { ProductLabelList } from "@/components/product/ProductLabelList";
import { PROMOTIONS_ENABLED } from "@/features/promotions/config";
import { useProductCard } from "@/features/search/components/product-card/product-card.context";

/** Design (Dieke, 2026-10): a card shows two labels at most, Must go > Boosted > Curated > Showroom (2026-10-28). */
const MAX_CARD_LABELS = 2;

/**
 * Every badge shown under a card, and the only place that decides which appear.
 *
 * The search API works these out server-side into `product.labels`, and `toCardProduct` fills the
 * same field in for a product that came from the gateway, so there is nothing to work out here.
 */
export const ProductCardLabels = () => {
  const { product } = useProductCard();
  const { curated, boosted, showroom } = product.labels;

  return (
    <ProductLabelList
      curated={curated}
      boosted={boosted}
      showroom={showroom}
      paidLabel={PROMOTIONS_ENABLED ? product.promotion?.label?.text : null}
      max={MAX_CARD_LABELS}
      /*
       * Boosted already ranks second; keep it pinned anyway (EU Omnibus, paid ranking must be
       * disclosed). "Boosted" is the boost that lifts the listing to the top of its category, and
       * search cards carry no "Sponsored" line. So the cap never drops it: Must go + Curated +
       * Boosted shows Must go + Boosted.
       */
      keepBoosted={boosted}
    />
  );
};
